import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {ChangePasswordService} from './change-password.service';
import {ResponseMessage} from './domain/response.message';
import {PasswordInfo} from './domain/password.info';
import {PasswordValidation} from './validators/password-validation';

@Component({
  selector: 'lib-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @Input()
  HTTPOptions = {};
  @Input()
  api;
  @Output()
  response = new EventEmitter();
  @Output()
  resetClicked = new EventEmitter();
  successMessage;
  resetPasswordForm: FormGroup;
  confirmPassword: string;
  resetPasswordRespond = new ResponseMessage<any>();
  passwordInfo: PasswordInfo;

  ngOnInit() {
    this.passwordInfo = new PasswordInfo();
    this.resetPasswordForm = new FormGroup({
      'currentPassword': new FormControl(this.passwordInfo.currentPassword, [
        Validators.required,
        Validators.minLength(4)
      ]),
      'newPassword': new FormControl(this.passwordInfo.newPassword, [
        Validators.required,
        Validators.minLength(4)
      ]),
      'confirmPassword': new FormControl(this.confirmPassword, [
        Validators.required
      ]),

    }, {
      validators: PasswordValidation.MatchPassword
    });
  }

  get confirmPass(): AbstractControl {
    return this.resetPasswordForm.get('confirmPassword');
  }

  get newPass(): AbstractControl {
    return this.resetPasswordForm.get('newPassword');
  }

  get currentPass(): AbstractControl {
    return this.resetPasswordForm.get('currentPassword');
  }

  reset(): void {
    this.resetPasswordRespond = new ResponseMessage<any>();
    this.resetClicked.emit();
    this.setValue();
    this.passwordService.changePassword(this.api, this.passwordInfo, this.HTTPOptions).subscribe(res => {
        console.log(res);
        this.resetPasswordRespond.errorOccurred = false;
        this.resetPasswordRespond.errorCode = '201';
        this.response.emit(this.resetPasswordRespond);
      },
      err => {
        console.log(err);
        this.resetPasswordRespond.errorOccurred = true;
        this.resetPasswordRespond.errorDescription = err.error.errorKey;
        // this.responseMessage.errorDescription = err.fieldErrors.field + ' ' + err.fieldErrors[0].message;
        this.resetPasswordRespond.errorCode = err.status;
        if (err.status === '400') {
          this.resetPasswordRespond.errorDescription = err.error.title;
        }
        console.log(err.url + ': ' + err.status + ': ' + err.statusText);
        this.response.emit(this.resetPasswordRespond);
      });
  }

  setValue() {
    this.passwordInfo.newPassword = this.resetPasswordForm.controls['newPassword'].value;
    this.passwordInfo.currentPassword = this.resetPasswordForm.controls['currentPassword'].value;
    this.confirmPassword = this.resetPasswordForm.controls['confirmPassword'].value;

  }

  constructor(private passwordService: ChangePasswordService) {

  }

}
